export const auditBookingsApprovalsKeys = {
  all: () => ["auditBookingsApprovals"],
  create: () => [...auditBookingsApprovalsKeys.all(), "create"]
};
